import type { IHubSubscribedSolution } from "@models";
import { useHubSolutions } from "@query";
import { useMemo } from "react";

interface IUseHomeApplicationSolutionsOptions {
  companyUuid: string;
  appMapId: string;
  enabled: boolean;
}

export function useHomeApplicationSolutions({
  companyUuid,
  appMapId,
  enabled,
}: IUseHomeApplicationSolutionsOptions) {
  const { data: hubSolutions, isLoading } = useHubSolutions(
    companyUuid,
    appMapId,
    {
      enabled: enabled && !!companyUuid && !!appMapId,
    },
  );

  const solutions = useMemo(
    (): IHubSubscribedSolution[] =>
      hubSolutions?.filter(
        (solution) =>
          !solution.subscriptionStatus ||
          solution.subscriptionStatus === "ACTIVE",
      ) ?? [],
    [hubSolutions],
  );

  return {
    solutions,
    isLoading,
  };
}
